import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NEW, USER_INFO } from 'src/shared/data-store';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  showLoader = new BehaviorSubject(false);
  priceScenarioLoader = new BehaviorSubject(false);
  priceScenarioTableData = new BehaviorSubject([]); // used to render table
  // fullAndOriginalPriceScenarioTableData = new BehaviorSubject([]);
  // originalDataReadOnly = new BehaviorSubject([]);
  // cleanPriceScenarioTableData = new BehaviorSubject([]);
  tableDataForDuplicateIndividualChange = new BehaviorSubject([]); // used when individual cell change in duplicate, with no mutation.

  childMode = new BehaviorSubject(NEW);
  validChildName = new BehaviorSubject(true);
  searchQueryPriceScenarioTable = new BehaviorSubject('');
  inflationIndividualChange: any = new BehaviorSubject({}); // to track individual cell chage
  userType = new BehaviorSubject('');
  tableDataWithUpdatedValues = new BehaviorSubject([]); // used for tracking table data when multiple filters are applied
  tableDataForFiltering = new BehaviorSubject([]); // original data with no mutation
  downloadCsvOutput = new BehaviorSubject('');
  constructor(private http: HttpClient) {}
  getRequest(url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',

      'Access-Control-Allow-Methods': '*',
    });

    let options = {
      headers: headers,
      responseType: 'text' as 'text',
    };
    return this.http
      .get(environment.api_base_url + url, options)
      .toPromise()
      .catch((err) => {});
  }

  getRequestWithJsonData(url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
    });

    let options = {
      headers: headers,
    };
    return this.http
      .get(environment.api_base_url + url, options)
      .toPromise()
      .catch((err) => {});
  }

  getRequestWithParams(url, paramsObject: any) {
    const params = Object.entries(paramsObject).reduce(
      (params, [key, value]) => {
        if (value) {
          return params.set(key, value.toString());
        }
        if (value == 0) {
          return params.set(key, value.toString());
        }
        return params;
      },
      new HttpParams(),
    );
    return this.http
      .get(environment.api_base_url + url, { params })
      .toPromise()
      .catch((err) => {
        console.log(err);
      });
  }

  getUserDeatailsForScenarioSave() {
    let userInfo: any = localStorage.getItem(USER_INFO);
    let username = '';
    let email = '';
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      if (Object.keys(userInfo).length) {
        username = userInfo.name;
        email = userInfo.username;
      }
    }
    return { username, email };
  }

  getRequestWithParams2(url, paramsObject: any) {
    // Remove any empty keys from params
    Object.keys(paramsObject).forEach((key) => {
      if (!paramsObject[key].length) {
        delete paramsObject[key];
      }
    });

    const params = Object.entries(paramsObject).reduce(
      (params, [key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => {
            params = params.append(key, item);
          });
        } else if (value) {
          params = params.set(key, value.toString());
        }
        return params;
      },
      new HttpParams(),
    );

    return this.http
      .get(environment.api_base_url + url, { params })
      .toPromise()
      .catch((err) => {
        console.log(err);
      });
  }

  getRequestWithDynamicParams(url, params) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
    });

    let options = {
      headers: headers,
      params: params,
    };
    return this.http
      .get(environment.api_base_url + url, options)
      .toPromise()
      .catch((err) => {
        console.log(err);
      });
  }

  postRequest(payload, url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let options = {
      headers: headers,
    };
    return this.http
      .post(environment.api_base_url + url, payload, options)
      .toPromise()
      .catch((error) => {
        throw error;
      });
  }

  putRequest(payload, url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let options = {
      headers: headers,
    };
    return this.http
      .put(environment.api_base_url + url, payload, options)
      .toPromise()
      .catch((err) => {});
  }

  deleteRequest(payload, url) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let options = {
      headers: headers,
      body: { ...payload },
    };
    return this.http
      .delete(environment.api_base_url + url, options)
      .toPromise();
  }
}
